import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex items-center justify-center">
    <div className="px-4 py-1.5 bg-primary/40 rounded text-[8px] text-primary font-medium">Кнопка</div>
  </div>
);

export default Thumbnail;
